import React, { Component } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { I18nProvider } from '@fiverr-private/i18n-react';

const I18nProviderWrapper = (WrappedComponent) => {
    // eslint-disable-next-line react/prefer-stateless-function
    class MenuI18nProvider extends Component {
        render() {
            const { locale } = getContext();

            return (
                <I18nProvider locale={locale}>
                    {({ i18n }) => <WrappedComponent i18n={i18n} {...this.props} />}
                </I18nProvider>
            );
        }
    }

    return MenuI18nProvider;
};

export default I18nProviderWrapper;
